module.exports = {"210902002":"新兴街道","210902003":"和平街道","210902004":"西山街道","210902005":"河北街道","210902006":"站前街道","210902007":"西阜新街道","210902008":"五龙街道","210902009":"平安西部街道","210902010":"工人村街道","210902011":"东梁街道","210902101":"韩家店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210902.json
// module id = 564
// module chunks = 0